module.exports = __webpack_public_path__ + "img/bg1.1c88e6dd.png";